export enum AccessibilityType {
    Public = 10,
    Private = 20,
    OnDemand = 30,
}
